import  { useState } from "react";
import "./scroll.css"; // Add your CSS file
import Whatsapp from "../../assets/whatsapp.png";
import Contact from "../../assets/contact.png";
import { Link } from "react-router-dom";

function WhatsAppButton() {
  const [isOpen, setIsOpen] = useState(false);


  const toggleWhatsApp = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div style={{ position: "fixed", bottom: 20, left: 30, zIndex: 9999 }}>
      <button className="Social-button" onClick={toggleWhatsApp} aria-label="Toggle contact options">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2L10 10L10 18"
            stroke="#FBFBFB"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <path
            d="M18 10H10L2 10"
            stroke="#FBFBFB"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="social-medial-div" style={{ position: "absolute", bottom: 5, left: 45,display:"flex",justifyContent:"space-evenly" }}>
             <Link
            to="tel:+YOUR_PHONE_NUMBER"
            style={{ marginRight: 10 }}
          >
           <img src={Contact} alt="Contact" />
          </Link>
          <Link
            to="https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER"
            target="_blank"
            rel="noopener noreferrer"
          >
          <img src={Whatsapp} alt="WhatsApp" />
          </Link>
         
        </div>
      )}
    </div>
  );
}

export default WhatsAppButton;
